<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">应用市场</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">名片统计</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="content mpjb">
            <a-card title="名片简报" style="width: 100%">
                <a slot="extra" href="#">more</a>
                <a-row>
                    <a-col :span="6">
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/1.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    新增访客人数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/2.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    已转线索人数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/2.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    授权手机号人数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/4.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    咨询人数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-divider />
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/5.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    浏览次数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-divider />
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/6.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    转发次数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-divider />
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/7.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    提交表单次数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="6">
                        <a-divider />
                        <a-row>
                            <a-col :span="4">
                                <img src="../../../static/8.png" alt="">
                            </a-col>
                            <a-col :span="20">
                                <div class="data">
                                    拨打电话次数
                                    <span>-</span>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="4"></a-col>
                            <a-col :span="20">
                                <div class="percent">
                                    环比
                                    <span class="zj">--  <a-icon type="arrow-up" /></span>
                                    <span class="total">累计<span>-</span></span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-card>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/cardsta.vue